const isTouchOnly = () => {
  // lifted from https://github.com/hammerjs/hammer.js/blob/a28c530297f6e66785476013a6c9162305a2ce42/hammer.js#L80-84
  const MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
  const SUPPORT_TOUCH = 'ontouchstart' in window;
  const SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
  return SUPPORT_ONLY_TOUCH;
};

export default {
  isTouchOnly
};



// WEBPACK FOOTER //
// ./starling/src/lib/mobile.js